<template v-if="initiatives">
  <div class="title2 mt4" v-if="hasActiveInitiatives">
    Актуальные инициативы
  </div>
  <w-flex class="wrap fill-width justify-center grow row">
    <template v-for="initiative in activeInitiatives" :key="initiative.initiativeId">
        <InitiativeCard class="mt4 ml2 mr2" :initiative="initiative" :user="user"/>
    </template>
  </w-flex>
  <div class="title2 mt4" v-if="hasFinishedInitiatives">
    Завершенные инициативы
  </div>
  <div class="caption mt1" v-if="hasFinishedInitiatives">
    но их все равно можно поддерживать
  </div>
  <w-flex class="wrap fill-width justify-center grow row">
    <template v-for="initiative in finishedInitiatives" :key="initiative.initiativeId">
        <InitiativeCard class="mt4 ml2 mr2" :initiative="initiative" :user="user"/>
    </template>
  </w-flex>
</template>

<script>
import InitiativeCard from './InitiativeCard.vue';

import {ref} from 'vue';
import {getInitiatives} from './util.js';

export default {
  name: 'InitiativeCards',
  components: {
    InitiativeCard
  },
  props: {
    user: Object
  },
  data() {
    return {
      hasActiveInitiatives: this.activeInitiatives.length > 0,
      hasFinishedInitiatives: this.finishedInitiatives.length > 0
    }
  },
  async setup() {
    //var articles = await getArticles();

    var initiatives = await getInitiatives();
    var activeInitiatives = ref(initiatives.filter(i => i.score < 100));
    var finishedInitiatives = ref(initiatives.filter(i => i.score >= 100));
    return { activeInitiatives, finishedInitiatives }
  },
  methods: {
  }
}
</script>

<style>
.w-card {

}
</style>
